import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('Spacer', {
    root: (props) => [
        {
            label: `${props.width || 0}-by-${props.height || 0}`,
            width: props.width,
            height: props.height,
        },
    ],
});
export const Spacer = ({ width = 0, height = 0 }) => {
    return isolateComponent("div", { css: Styles.root({ width, height }) });
};
//# sourceMappingURL=Spacer.js.map
// @zapier/design-system@6.27.0 (617a97f69)
